import React, { useEffect, useState } from "react";
import '../../cssfiles/homepage.css';
import './Alerts.css';
import { Box, Divider, Typography,Link, colors } from "@mui/material";
import Chart from "react-apexcharts";
//import ErrorOutlineIcon from '@mui/icons-material/FiberManualRecord';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useDispatch, useSelector } from "react-redux";
import { Block } from "@mui/icons-material";
import { setPage } from "../../store/pageselect_data";
import { tag_collection_query_db } from '../DataCollection';
import { getDeviceDetailsInformationProjectwise, getTagDetailsInformationProjectwise  } from "../../Restclient/datacollection";
import BlinkingAlarmIcon from '../CommonComponents/BlinkingAlarmIcon';
import BlinkingWarningIcon from '../CommonComponents/BlinkingWarningIcon';
import BlinkingInformationIcon from '../CommonComponents/BlinkingInformationIcon';
import BlinkingSevereIcon from '../CommonComponents/BlinkingSevereIcon';
import AlarmIcon from '../CommonComponents/AlarmIcon';
import WarningIcon from '../CommonComponents/WarningIcon';
import InformationIcon from '../CommonComponents/InformationIcon';
import SevereIcon from '../CommonComponents/SevereIcon';
import { updatedevicedetailsobject, updatetagdetailsobject } from "../../store/mainpage_data";

export default function Alerts ({rightpanealarms}) {
    const theme = useSelector((state) => state.themedata.theme)
    const livealarmarray = useSelector((state) => state.alarmdata.livealarmarray)
    //const taglistarray = useSelector((state) => state.mainpagedata.taglistarray)
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const dashboardjsontags = useSelector((state) => state.mainpagedata.dashboardjsontags)
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    const [alertslist, setalertslist] = useState([{
        tagvalue:20,
        general_tagname:"xyz"
      }])
    const dispatch = useDispatch()
    const [options, setOptions] = useState({});
    const [series, setSeries] = useState([]);
    const [unack, setunack] = useState('')
    const [alerts, setAlerts] = useState([]);  
    const handlePageChange = (page) => {
        dispatch(setPage(page));
    };
    const [alarmsdataRecords, setAlarmsDataRecords] = useState([]);
    const [taginformation, setTaginformation] = useState({});
    const [deviceinformation,setDeviceinformation] = useState({});
    useEffect(()=>{
       
        var filterarray = [];
        var alertobject = {};
        
        if(livealarmarray!== null && livealarmarray!== undefined && livealarmarray.length>0){
            if( dashboardjsontags!== null &&  dashboardjsontags!== undefined &&  dashboardjsontags.length>0){
                    for(var i=0 ; i<livealarmarray.length ;i++){
                        
                        for(var j=0;j<dashboardjsontags.length;j++){
                            if(dashboardjsontags[j] == livealarmarray[i].TagID) 
                            {
                                if(!alertobject.hasOwnProperty(livealarmarray[i].TagID)){
                                    alertobject[livealarmarray[i].TagID] = livealarmarray[i];
                                    filterarray.push(livealarmarray[i]);
                                }
                                
                            }
                        }
                    }
            }
        }

        setAlerts(filterarray);
    },[dashboardjsontags, livealarmarray])


    /////
    const alertlistcallback = (res) => {
        setalertslist([{
            tagvalue:20,
            general_tagname:"xyz"
          }])
    } 

    const getTagDetailsInformationcallback = (datareceived) => {
        if(datareceived && datareceived.data && datareceived.data.taginformationkey){
            console.log("datareceived in getTagDetailsInformationcallback",datareceived)
            var taglist = datareceived?.data?.taginformationkey;
            
            // var taginformationobject = {};
            // for(const key of Object.keys(taglist)){
            //     taginformationobject[key] = taglist[key];
            // }
            
            if(Object.keys(taglist).length > 0){
                setTaginformation(taglist)
                dispatch(updatetagdetailsobject(taglist))
            }
        }
    }

    const getDeviceDetailsInformationcallback = (datareceived) => {
        if(datareceived && datareceived.data && datareceived.data.deviceinformationkey){
            
            var devicelist = datareceived?.data?.deviceinformationkey;
            // var deviceinformationobject = {};
            // for(var i=0;i<devicelist.length;i++){
            //     deviceinformationobject[devicelist[i].DeviceID] = devicelist[i];
            // }
            if(Object.keys(devicelist).length > 0){
                setDeviceinformation(devicelist)
                dispatch(updatedevicedetailsobject(devicelist))
            }
        }
       
    }

    useEffect(()=>{
        if(selectedprojectname != undefined || selectedprojectname != null || selectedprojectname != ''){
            console.log("selectedprojectname useeffect in alerts",selectedprojectname,"userdetails",userdetails)
            if(userdetails && userdetails.Projectid && userdetails.Projectlist){
                getTagDetailsInformationProjectwise(selectedprojectname,userdetails.Projectlist, getTagDetailsInformationcallback);
                getDeviceDetailsInformationProjectwise(selectedprojectname,userdetails.Projectlist, getDeviceDetailsInformationcallback);
            }
        }
    },[selectedprojectname])
    
    useEffect(()=>{

        //deviceinformation[taginformation[alert.tagid].DeviceID].Name+
        //var taglist = tag_collection_query_db.map((currenttag)=>{
        //    return currenttag.tagname;
        //});
        //var datacurrent = alerts;
        var datacurrent = alerts;
        var totalalarmscountdata= datacurrent.length;
        var unackalarmscountdata= 0;
        var totalseverecount= 0;
        var totalalarmcount= 0;
        var totalwarningcount= 0;
        var totalinformationcount= 0;

        for(var i=0;i<datacurrent.length;i++){
            if(datacurrent[i].AcknowledgementStatus == false){
                unackalarmscountdata++;
            }
            console.log("datacurrent[i].AlertClass == 100",datacurrent[i].AlertClass == 100)
            if(datacurrent[i].AlertClass == 100){
                totalseverecount++;
            }else if(datacurrent[i].AlertClass == 75){
                totalalarmcount++;
            }else if(datacurrent[i].AlertClass == 50){
                totalwarningcount++;
            }else if(datacurrent[i].AlertClass == 25){
                totalinformationcount++;
            }
        }

        // Get computed CSS color values
        const rootStyles = getComputedStyle(document.documentElement);
        const redColor = rootStyles.getPropertyValue('--RedBaseColor').trim() || '#dc272d';
        const amberColor = rootStyles.getPropertyValue('--AmberBaseColor').trim() || '#ee8c19';
        const yellowColor = rootStyles.getPropertyValue('--YellowBaseColor').trim() || '#ffd000';
        const greenColor = rootStyles.getPropertyValue('--GreenBaseColor').trim() || '#00943d';
        
        console.log('Chart colors:', redColor, amberColor, yellowColor, greenColor);

        var options = {
            chart: {
                type: 'bar',
                stacked: true,
                stackType: '100%',
                toolbar: {
                    show: false
                },
                offsetX: -10,
            },
            grid: {
                show: true,
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },
            tooltip: {
                enabled: false,
            },
            states: {
                active: {
                    filter: {
                        type: 'none'
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: false,
                    barHeight: '40%',
                    dataLabels: {
                        position: 'center',
                    }
                }
            },
            dataLabels: {
                enabled:true,
                formatter: function(value, { seriesIndex, dataPointIndex, w }) {
                    return  w.config.series[seriesIndex].data
                },
                style:{
                    colors:['#ffffff'],
    
                },
            },
            colors: ['#dc272d', '#ee8c19', '#ffd000', '#00943d'],
            fill: {
                type: 'solid',
                opacity: 1
            },
            stroke: {
                width: 0,
                colors: ['transparent']
            },
            xaxis: {
                show: false,
                labels: {
                    show: false,
                  style: {                                
                      fontSize: '12px',
                      fontWeight: 400,
                      colors: "var(--GreyVariation_1)",
                      fontFamily:"Roboto",
                  } 
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                }
            },
            yaxis: {
                show: false,
                labels: {
                    show: false,
                    style: {                                
                        fontSize: '12px',
                        fontWeight: 400,
                        colors: "var(--GreyVariation_1)",
                        fontFamily:"Roboto",
                        
                    },
                    offsetX: -40
                },
            },
            legend: {
                show: true,
                customLegendItems: ['Severe','Alarm','Warning','Info'],
                position: 'bottom',
                fontSize: '8px',
                fontWeight: 400,
                horizontalAlign:"center",
                offsetX: -20,
                offsetY: 0,
                itemMargin: {
                    horizontal: -5,
                    vertical: 0
                },
                labels:{
                    colors:"var(--PrimaryText)",
                },
                markers: {
                    shape: 'circle',
                    width: 0.5,
                    height: 0.5,
                    radius: 0.5,
                }
            },
        };
        var series = [{
            name: 'Severe',
            data: [totalseverecount]
        },
        {
            name: 'Alarm',
            data: [totalalarmcount]
        },
        {
            name: 'Warning',
            data: [totalwarningcount]
        },
        {
            name: 'Information',
            data: [totalinformationcount]
        },]

        setunack(unackalarmscountdata);
        setAlarmsDataRecords(alerts)
        setOptions(options)
        setSeries(series)
    },[alerts])
    
    return(
        <Box style={{padding: '10px',height:'100%',boxSizing: 'border-box' ,display:'flex',flexDirection:'column'}}>
            <Box style={{display: 'flex', flexDirection: 'row'}}>
                <Typography className="total-alarms-heading"> Total </Typography>
                <div style={{flexGrow: 1}}></div>
                <Typography className="total-alarms-value"> {alerts.length} </Typography>
            </Box>
            <Box style={{display: 'flex', flexDirection: 'row',marginTop:"16px"}}>
                <Typography className="total-alarms-subheading"> Unacknowledged Alerts</Typography>
                <div style={{flexGrow: 1}}></div>
                <Typography className="total-alarms-value-sub"> {unack} </Typography>
            </Box>
            <Box style={{width: '100%', marginTop: '8px', overflow: 'hidden'}}>
                <Chart
                    options={options}
                    series={series}
                    type={'bar'}
                    height={120}
                    width="100%"
                />
            </Box>
            <Typography className="total-alarms-value" style={{textAlign: 'left', fontSize: '12px', fontWeight: 400, marginBottom: '5px', marginTop: '0px'}}> Recent Alerts: </Typography>
            <Divider style={{backgroundColor: (theme=='light')?"#E0E0E0":"#3C3C3C"}}/>
            {alerts.map((alert)=>{
                
                return (<Box style={{display: 'flex', flexDirection: 'column'}}>
                    <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', justifyContent: 'center',marginLeft: '7px'}}>
                        {(Number(alert.AlertClass) == 100) && <SevereIcon />}
                        {(Number(alert.AlertClass) == 75) && <AlarmIcon />}
                        {(Number(alert.AlertClass) == 50) && <WarningIcon />}
                        {(Number(alert.AlertClass) == 25) && <InformationIcon />}
                        <div style={{flexGrow: 1}}></div>
                        <Typography className="alarm-heading" style={{fontSize: '12px', fontWeight: 400,marginRight:"7px"}}>  Value </Typography>
                        <Typography className="alarm-time" style={{fontSize: '12px', fontWeight: 400,marginRight:"7px"}}> {alert.TagValue} </Typography>
                    </Box>
                    <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', marginBottom: '12px'}}>
                        <div style={{width:"50%"}}><Typography className="code-heading" style={{fontSize: '12px', fontWeight: 400, marginLeft: '0px'}}> {(taginformation[alert.TagID]?.DeviceID != undefined && deviceinformation[taginformation[alert.TagID]?.DeviceID]?.Name != undefined)?(deviceinformation[taginformation[alert.TagID]?.DeviceID]?.Name+":"+taginformation[alert.TagID]?.Alias):""} </Typography></div>
                        <div style={{flexGrow: 1}}></div>
                        <a href="javascript:;" className="view-link" style={{fontSize: '10px', fontWeight: 400, marginLeft:'auto',  textDecoration:'underline'}} onClick={() => handlePageChange('alarm')}>View</a>                    
                    </Box>
                    <Divider style={{backgroundColor: (theme=='light')?"#E0E0E0":"#3C3C3C"}}/>
                </Box>)
            })}
            

            {/*
            <Box style={{display: 'flex', flexDirection: 'column'}}>
                <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', justifyContent: 'center'}}>
                    <ErrorOutlineIcon style={{width: '12px', height: '12px', marginRight: '5px',marginTop:'2px', backgroundColor: 'var(--YellowBaseColor)',color: 'var(--White)',borderRadius:"6px"}}/>
                   <Typography className="alarm-heading" style={{fontSize: '12px', fontWeight: 400}}>  Maintenance Due </Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Typography className="alarm-time" style={{fontSize: '10px', fontWeight: 400}}> 14 hrs 20 mins ago </Typography>
                </Box>
                <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', marginBottom: '12px'}}>
                    <Typography className="code-heading" style={{fontSize: '12px', fontWeight: 400, marginLeft: '18px'}}> Asset 3 </Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Link className="view-link" style={{fontSize: '10px', fontWeight: 400}}> View </Link>
                </Box>
                <Divider style={{backgroundColor: (theme=='light')?"#E0E0E0":"#3C3C3C"}}/>
            </Box>
            <Box style={{display: 'flex', flexDirection: 'column'}}>
                <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', justifyContent: 'center'}}>
                    <ErrorOutlineIcon style={{width: '12px', height: '12px', marginRight: '5px',marginTop:'4px', backgroundColor: 'var(--RedBaseColor)',color: 'var(--White)',borderRadius:"6px"}}/>
                    <Typography className="alarm-heading" style={{fontSize: '12px', fontWeight: 400}}>  Breaker Trip </Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Typography className="alarm-time" style={{fontSize: '10px', fontWeight: 400}}> 14 hrs 20 mins ago </Typography>
                </Box>
                <Box style={{display: 'flex', flexDirection: 'row', marginTop: '12px', marginBottom: '12px'}}>
                    <Typography className="code-heading" style={{fontSize: '12px', fontWeight: 400, marginLeft: '18px'}}> Asset 2 </Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Link className="view-link" style={{fontSize: '10px', fontWeight: 400,}}> View </Link>
                </Box>
                <Divider style={{backgroundColor: (theme=='light')?"#E0E0E0":"#3C3C3C"}}/>
            </Box>
            */}
            <div style={{flexGrow: 1}}> </div>                
            <a href="javascript:;" className="view-link" style={{fontSize: '16px',marginLeft:'auto', fontWeight: 400, textDecoration:'underline'}} onClick={() => handlePageChange('alarm')}>Go to Alert Module</a>
        </Box>
    )
}